module.exports = __webpack_public_path__ + "img/002.c21b3a20.png";